import React, { useState, useEffect } from 'react';
import { Button, Box, Typography } from '@mui/material';
import { useTranslation } from "react-i18next";
import { LOANS_APPLICATION } from "../locales/namespaces";
import ArrowLeft from "../../../../src/assets/images/icons/buttonsIcons/arrowLeftIcon";

export default function SimplePagination({ min, max, active, activeIndexSubItem, onChange, formFields }) {
  const { t } = useTranslation(LOANS_APPLICATION)
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeSubIndex, setActiveSubIndex] = useState(0);

  const currentSubgroups = formFields[activeIndex]?.questions?.subgroups || [];
  const isNextDisabled = activeIndex === max && (!currentSubgroups.length || activeSubIndex === currentSubgroups.length - 1);
  const isPrevDisabled = activeIndex === min && (!currentSubgroups.length || activeSubIndex === 0);

  const handleNext = () => {
    if (currentSubgroups.length > 0 && activeSubIndex < currentSubgroups.length - 1) {
      setActiveSubIndex(prev => {
        const newSubIndex = prev + 1;
        onChange(activeIndex, newSubIndex);
        return newSubIndex;
      });
    } else if (activeIndex < formFields.length - 1) {
      const nextIndex = activeIndex + 1;
      const nextSubgroups = formFields[nextIndex]?.questions?.subgroups || [];
      setActiveIndex(nextIndex);
      const newSubIndex = nextSubgroups.length > 0 ? 0 : undefined;
      setActiveSubIndex(newSubIndex);
      onChange(nextIndex, newSubIndex);
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePrev = () => {
    if (currentSubgroups.length > 0 && activeSubIndex > 0) {
      setActiveSubIndex(prev => {
        const newSubIndex = prev - 1;
        onChange(activeIndex, newSubIndex);
        return newSubIndex;
      });
    } else if (activeIndex > 0) {
      const prevIndex = activeIndex - 1;
      const prevSubgroups = formFields[prevIndex]?.questions?.subgroups || [];
      const newSubIndex = prevSubgroups.length > 0 ? prevSubgroups.length - 1 : undefined;
      setActiveIndex(prevIndex);
      setActiveSubIndex(newSubIndex);
      onChange(prevIndex, newSubIndex);
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };



    // Synchronization state from external props  
    useEffect(() => {
      setActiveIndex(active  ?? 1);
    }, [active]);

    useEffect(() => {
      setActiveSubIndex(activeIndexSubItem  ??  1);
    }, [activeIndexSubItem]);


  return (
    <Box display="flex" alignItems="center" gap={4} sx={{ margin: '40px 0 0 0' }} className="pagination-loans-application">
      <Button
        className="pagination-btn"
        variant="outlined"
        onClick={handlePrev}
        disabled={isPrevDisabled}
        sx={{
          padding: '10px',
          minWidth: 'auto',
          borderRadius: '8px !important',
          svg: { width: '20px', path: '#485476', pointerEvents: 'none' }
        }}
      >
        <ArrowLeft />
      </Button>

      <Typography className="color-secondary pagination-btn" variant="body1">
        {activeIndex + 1}{currentSubgroups.length > 0 ? `.${activeSubIndex + 1}` : ''} {t("from")} {max + 1}
      </Typography>

      <Button
        variant="outlined"
        onClick={handleNext}
        disabled={isNextDisabled}
        sx={{
          padding: '10px',
          minWidth: 'auto',
          borderRadius: '8px !important',
          svg: { width: '20px', transform: 'rotate(180deg)', path: '#485476', pointerEvents: 'none' }
        }}
      >
        <ArrowLeft />
      </Button>
    </Box>
  );
}
